// src/pages/NotFoundPage.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    return (
        <div>
            <h1>Page Not Found</h1>
            <p>Sorry, the page you are looking for does not exist.</p>
            <p>Please check the URL or go back to the dashboard.</p>
                <button>Go to Dashboard</button>    
        </div>
    );
}

export default NotFoundPage;